import React, {useState, useEffect} from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit.sass"

import Popup from "../../../components/Popup";
import notifyUser, {notifyAboutError} from "../../../methods/notifyUser";
import {httpClient} from "../../../funcs";
import {connect} from "react-redux";
import {useRoute} from "react-router5";
import {HelpView} from "../../Common/HelpView";
import ApiKeyField from "../../../components/ApiKeyField";
import { AdditionalServiceType } from "../../../util/AdditionalServiceType";

type Props = {
    close: Function,
    bitrixConfig: any,
    $store: any,
    $commitToStore: Function,
}

let BitrixIntegrationPopup: any = function BitrixIntegrationPopup(props: Props) {
    const $router = useRoute()
    const [configurationTariffs, setConfigurationTariffs] = useState<any[]>([])

    useEffect(() => {
        loadConfigurationTariffs()
    }, [])

    async function loadConfigurationTariffs() {
        try {
            const {data: tariffs} = await httpClient.get("/configuration-tariffs");
            setConfigurationTariffs(tariffs)
        } catch(error) {
            notifyAboutError(props, error)
        }
    }

    function getConfigurationPrice(type: string): number {
        const tariff = configurationTariffs.find(t => t.type === type)
        return tariff ? tariff.price / 100 : 1500
    }

    function goToTariffsWithBitrixConfiguration() {
        props.close()
        localStorage.setItem('tariffs_active_tab', JSON.stringify('Тарифы'))
        $router.router.navigate(
            'packages-v2',
            {
                add_to_cart: AdditionalServiceType.BITRIX_CONFIGURATION,
            },
            { reload: false }
        )
    }

    function onCopy() {
        notifyUser(props, "Строка скопирована. Теперь вставьте ее в настройках виджета в Bitrix");
    }

    function apiKey() {
        return `${props.$store.userSession.realty_api_key}`
    }

    return <Popup
        maxWidth="650px"
        onClose={() => {
            props.close()
        }}
    >
        <div>
            <HelpView
                title={"Интеграция с Bitrix"}
                subtitle={"Интеграция добавляет виджет ОкиДоки в карточку сделки в Bitrix.\n" +
                    "Создавать договоры можно прямо из карточки сделки, при этом, есть возможность указать необходимый шаблон\n" +
                    "Все изменения статусов договора будут добавлены как комментарии в карточку сделки. \n" +
                    "\n" +
                    "Подробнее о том, как работает интеграция и как ее настроить, смотрите в нашем видео"}
                videoId={"96dX3tVahPw"}
                rutubeVideoId={"f7553c0407b4200f9952cd5ff51f9183"}
            />
            <hr className="newHR"/>
            <div className="Body_15" style={{textAlign: "left"}}>
                Чтобы настроить интеграцию с Bitrix - скопируйте ключ и вставьте его в настройках виджета и следуйте дальнейшим инструкциям
            </div>
            <div>
                <ApiKeyField
                    title="Ключ API"
                    value={apiKey()}
                    onCopy={onCopy}
                />

                <hr className="newHR"/>
                <div className="commonLabel" style={{marginTop: "20px"}}>
                    Нужна помощь с настройкой?
                </div>
                <div className="commonSubtitle" style={{marginTop: "10px"}}>
                    Наши специалисты помогут настроить интеграцию с Bitrix. Услуга будет добавлена в корзину на странице тарифов. Мы:
                    <ul style={{marginTop: "10px"}}>
                        <li>Настроим виджет в вашем Bitrix</li>
                        <li>Поможем настроить шаблоны договоров</li>
                        <li>Проведем тестовое создание договора</li>
                        <li>Обучим ваших сотрудников работе с интеграцией</li>
                    </ul>
                </div>
                <button
                    className="new withTitle _wa"
                    style={{marginTop: "15px"}}
                    onClick={goToTariffsWithBitrixConfiguration}
                >
                    <div className="buttonsContainer">
                        <span>Перейти к оплате (от {getConfigurationPrice('bitrix_configuration')} ₽)</span>
                    </div>
                </button>

                <hr className="newHR"/>
                <button
                    className="new withTitle _wa"
                    style={{marginTop: "15px"}}
                    onClick={() => {
                        props.close()
                    }}
                >
                    <div className="buttonsContainer">
                        <span>Закрыть</span>
                    </div>
                </button>
            </div>
        </div>
    </Popup>
}

BitrixIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(BitrixIntegrationPopup)

export default BitrixIntegrationPopup 